import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FaWhatsapp } from "react-icons/fa";
import { WHATSAPP_URL } from "@/lib/site";

export const StickyWhatsapp = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    let ticking = false;
    const onScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          setShow(window.scrollY > 300);
          ticking = false;
        });
        ticking = true;
      }
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          key="sticky"
          initial={{ opacity: 0, y: 30, scale: 0.8 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 30, scale: 0.8 }}
          transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-6 right-6 z-50 flex items-center group"
        >
          {/* Tooltip on Desktop */}
          <span className="hidden sm:inline-block mr-3 px-3 py-1.5 rounded-full bg-white/95 backdrop-blur-md text-clinic-ink text-xs font-sans font-medium shadow-soft border border-clinic-line/80 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
            Agendar consulta
          </span>

          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="sticky-whatsapp-cta"
            aria-label="Agendar consulta pelo WhatsApp"
            className="btn-shine relative flex items-center justify-center h-14 w-14 sm:h-14 sm:w-auto sm:px-5 rounded-full bg-clinic-rose text-white shadow-glow-rose hover:bg-clinic-roseDeep transition-all duration-300 active:scale-95"
          >
            {/* Animated Pulse Waves */}
            <span className="absolute inset-0 rounded-full bg-clinic-rose/40 animate-ping -z-10" />
            <span className="absolute -top-1 -right-1 flex h-3.5 w-3.5">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75"></span>
              <span className="relative inline-flex rounded-full h-3.5 w-3.5 bg-emerald-500 border-2 border-white"></span>
            </span>

            <FaWhatsapp className="h-6 w-6 shrink-0 transition-transform duration-300 group-hover:scale-110 group-hover:rotate-12" />
            <span className="font-sans font-semibold text-sm ml-2.5 hidden sm:inline">
              Agendar
            </span>
          </a>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

